import React from "react";
import { Box } from "@mui/material";
import { FONT_FAMILY, muiTheme } from "@common/themes";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

function TooltipV3({
  children,
  ...props
}: React.PropsWithChildren<TooltipProps>) {
  return (
    <Tooltip
      arrow
      disableInteractive={true}
      slotProps={{
        tooltip: {
          sx: {
            background: muiTheme.palette.common.black,
            color: muiTheme.palette.common.white,
            fontFamily: FONT_FAMILY.mediumV3,
            fontSize: 12,
          },
        },
        arrow: { sx: { color: muiTheme.palette.common.black } },
      }}
      {...props}
    >
      <Box>{children}</Box>
    </Tooltip>
  );
}

export default TooltipV3;
